import { GoogleJobsSchema } from "@/ui";
import { getGlobal } from "@/functions/getGlobal";
import { jobs_helper } from "@/helpers/jobs_helper";
import classes from "./styles.module.scss";
import FormSection from "@/components/FormSection";
import Title from "@/ui/Title";
import { consultant_helper } from "@/helpers/consultant_helper";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import SeoHead from "@/components/SeoHead";
import format from "date-fns/format/index.js";

function convertDateFormat(dateString) {
  try {
    return format(new Date(dateString), "dd MMMM yyyy");
  } catch (error) {
    console.error("Invalid date format. Please provide a valid ISO 8601 string.");
    return null;
  }
}

function generateSectors(sectors) {
  if (typeof sectors === "string") {
    return <Title title={sectors.name} className={classes.tag} tag="h6" />;
  } else if (Array.isArray(sectors)) {
    return (
      <div className={classes.tags}>
        {sectors.map((_item, index) => {
          return <Title key={index} title={_item.name} className={classes.tag} tag="h6" />;
        })}
      </div>
    );
  } else {
    return "-";
  }
}

export default function JobPage({ title, canonical, job, consultant }) {
  const global = getGlobal();
  const sectors = job?.categories.find((item) => item.name === "Sectors")?.values;
  const contractType = job?.categories.find((item) => item.name === "Contract Type")?.values[0]?.name;

  return (
    <>
      <SeoHead title={title} canonical={canonical} />
      <main className={classes.cont}>
        <GoogleJobsSchema
          job={job}
          employment_type={contractType}
          site_name={global["_theme.company.name"]}
          site_domain_link={global["_theme.company.domain"]}
          site_google_logo_link={global["_theme.company.logo"]}
        />
        <div className={`${classes.hero} ${classes.hasBg}`} style={{ backgroundImage: "url(/images/JobPageBG.png)" }}>
          <div className={classes.heroInner}>
            <h3>{job.title}</h3>
            <div className={classes.info}>
              <div className={classes.location}>
                <img src="/icons/location2.svg" alt="location" />
                {job.location}
              </div>
              {job.salary_package && (
                <div className={classes.salary}>
                  <img src="/icons/euro.svg" alt="euro" />
                  {job.salary_package}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={classes.sub_cont}>
          <div className={classes.job_description}>
            <div className={classes.left_col}>
              {consultant ? (
                <SourceFlowImage
                  src={consultant.profile_image ? consultant.profile_image : ""}
                  width={200}
                  alt={consultant.name ? consultant.name : ""}
                />
              ) : null}
              {consultant ? (
                <div className={classes.job_type}>
                  <div className={classes.title}>Consultant Name</div>
                  <h6 className={classes.value}>{consultant.name}</h6>
                </div>
              ) : null}

              <div className={classes.sector}>
                <div className={`${classes.title}`}>SECTOR</div>
                {generateSectors(sectors)}
              </div>
              <div className={classes.job_type}>
                <div className={classes.title}>JOB TYPE</div>
                <h6 className={classes.value}>{contractType}</h6>
              </div>
              <div className={classes.date}>
                <div className={classes.title}>DATE POSTED</div>
                <h6 className={classes.value}>{convertDateFormat(job.published_at)}</h6>
              </div>
            </div>
            <div className={classes.right_col}>
              <span dangerouslySetInnerHTML={{ __html: job.description }} />
            </div>
          </div>
          {/* <div className={classes.hidden}>
            <div className={classes.left_col}>
              <div className={classes.sector}>
                <div className={`${classes.title}`}>SECTOR</div>
                {generateSectors(sectors)}
              </div>
              <div className={classes.job_type}>
                <div className={classes.title}>JOB TYPE</div>
                <h6 className={classes.value}>{contractType}</h6>
              </div>
              <div className={classes.date}>
                <div className={classes.title}>DATE POSTED</div>
                <h6 className={classes.value}>{convertDateFormat(job.published_at)}</h6>
              </div>
              <h4>Consultant</h4>
            </div>
            <div className={classes.right_col}>
              <span dangerouslySetInnerHTML={{ __html: job.description }} />
            </div>
          </div> */}
        </div>
        <div className={classes.absolute}>
          <div className={classes.form}>
            <FormSection variant="dark" title="Apply now" jobId={job.id} redirect_url="/thank-you"></FormSection>
          </div>
        </div>
      </main>
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const job = jobs_helper.find(url_slug);
  const consultant =
    consultant_helper
      .fetch({
        filter: (i) => i.name.toUpperCase() == job.consultant_name.toUpperCase() || i.email == job.consultant_email,
      })
      .shift() ?? null;

  return {
    props: {
      title: job.title,
      canonical: `/jobs/${url_slug}`,
      job,
      consultant,
    },
  };
}

export async function getStaticPaths() {
  return { paths: jobs_helper.toPaths(), fallback: false };
}
